"use client";

import { IconHelp, IconSearch, IconSettings } from "@tabler/icons-react";
import * as React from "react";

import { EnhancedNavigation } from "@/components/layout/navigation/enhanced-navigation";
import { NavSecondary } from "@/components/layout/navigation/nav-secondary";
import { NavUser } from "@/components/layout/navigation/nav-user";
import { SmartLogo } from "@/components/shared/logo";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuItem,
  SidebarRail,
} from "@/components/ui/sidebar";
import { useNavigation } from "@/contexts/navigation-context";
import { getSecondaryMenu } from "@/lib/shared/menu-utils";
import { cn } from "@/lib/shared/utils";
import { useMemo } from "react";

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const { userRole } = useNavigation();

  const secondaryNavItems = useMemo(() => {
    return getSecondaryMenu(userRole);
  }, [userRole]);

  return (
    <Sidebar
      {...props}
      className={cn("font-sans border-r shadow-sm", props.className)}
      collapsible="icon"
    >
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <div className="flex items-center justify-center w-full">
              {/* Logo - automatically uses custom branding when available */}
              <div className="flex items-center justify-center group-data-[collapsible=icon]:opacity-0 group-data-[collapsible=icon]:invisible transition-all duration-200 delay-100">
                <a href="/" className="flex items-center">
                  <SmartLogo size="lg" />
                </a>
              </div>
            </div>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>

      <SidebarContent>
        <div className="flex flex-col h-full">
          {/* Enhanced Navigation */}
          <div className="flex-1 overflow-y-auto">
            <EnhancedNavigation />
          </div>

          {/* Static NavSecondary - Always Visible with divider */}
          <div className="flex-shrink-0">
            <div className="group-data-[collapsible=icon]:opacity-0 h-[1px] bg-border/40 mx-3 mb-1" />
            <div className="py-1">
              <NavSecondary items={secondaryNavItems} />
            </div>
          </div>
        </div>
      </SidebarContent>

      <SidebarFooter className="group-data-[collapsible=icon]:p-0">
        <NavUser />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  );
}
